export default __webpack_public_path__ + "static/media/Oliver_ParticleSmoke-32.b6d030e6.png";